import { render, staticRenderFns } from "./FormTratamientoColor.vue?vue&type=template&id=bf1efb46&scoped=true"
import script from "./FormTratamientoColor.vue?vue&type=script&lang=js"
export * from "./FormTratamientoColor.vue?vue&type=script&lang=js"
import style0 from "./FormTratamientoColor.vue?vue&type=style&index=0&id=bf1efb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1efb46",
  null
  
)

export default component.exports